import {_debug} from "../common/debugger/debugger";
import {TrustLevels} from "../types";

export interface Actions {
  submitOnline?: any;
  submitOffline?: any;
  loginBuerger?: any;
  reloginBuerger?: any;
  loginOrganisation?: any;
  reloginOrganisation?: any;
  logout?: any;
  logoutDocumentAccess?: any;
  leistung?: any;
  betroffenenRecht?: any;
  formular?: any;
  save?: any;
  saveUpdate?: any;
  sessionConfig?: any;
  sessionKeepalive?: any;
  downloadAntrag?: any;
  retrySubmitOnline?: any;
  retrySubmitOffline?: any;
  documentsRefresh?: any;
}

export interface UserState {
  loggedIn: null | boolean;
  accountType: null | 'buerger' | 'organisation'
  wrongAccountType: null | boolean,
  trustLevelInsufficient: null | boolean
}

export interface MetaData {
  id: string; // buerger_hoch_anonym
  leistungsschluessel: string
  mandant: string
  ars: string
  title: string; //buerger_hoch_anonym
  trustLevel: string; // eidas_substanziell
  formularType: null | 'buerger' | 'organisation' | 'hybrid';
  rueckkanalwahl: boolean;
  willensbekundung: boolean;
  mindestalter: number; // 18
  rueckkanaloption: string;
  bescheid_schriftform: boolean;
  behoerde: string; // demobehoerde
  description: string; // Tolles Formular
}

export interface UserDecisions {
  preview?: null | boolean;
  accountType?: null | 'buerger' | 'organisation',
  offline?: null | boolean;
  language?: null | string;
}

export interface Features {
  supportsSubmitOffline: boolean;
  formularType: null | 'buerger' | 'organisation' | 'hybrid';
  inactive: boolean;
}

export interface AccountData {
  userdata?: AccountUserData;
  links: AccountLinks
}

export interface AccountUserData {
  providerName: 'ELSTER OK' | 'BundID'
  trustLevel: TrustLevels
}

export interface AccountLinks {
  logout?: string;
  loginOrganisation?: string
  loginBuerger?: string
  sessionKeepalive?: string
}

// get form meta data based on API result

export function getMetaData(initialData): MetaData {
  // maps metaData for internal use
  const metaData = initialData.metadata;

  _debug('metaData:', metaData);
  return metaData;
}

// get endpoints based on API result

export function getEndpoints(initialData) {
  // maps endpoints for internal use

  /* const endpoints = {
       dse: initialData.dse, // e.g. /leistungsbeantragung/api/formulare/buerger_hoch_anonym/dse
       layout: initialData.layout, // /leistungsbeantragung/api/formulare/buerger_hoch_anonym/layout
       leistungsbeschreibung: initialData.leistungsbeschreibung, // '/leistungsverzeichnis/leistung/buerger_hoch_anonym '
       betroffenenrechteFormular: initialData['betroffenenrechte-formular'], // /leistungsbeantragung/demobetRech
       fileUpload: initialData['file-upload'], // /documentservice/documents
   } */
  const endpoints = initialData.api;

  _debug('endpoints:', endpoints);
  return endpoints;
}


// get possible ui actions based on API result

export function getPossibleActions(result) {
  // maps action ID's for internal use
  // ToDo: sync naming for easier processing

  const possibleActionsMap: Actions = {
    submitOnline: 'submitOnline', // submitOnline action ID
    submitOffline: 'submitOffline', // submitOffline action ID
    loginBuerger: 'loginBuerger', // login-buerger action ID
    reloginBuerger: 'reloginBuerger', // relogin-buerger action ID
    loginOrganisation: 'loginOrganisation',
    reloginOrganisation: 'reloginOrganisation',
    logout: 'logout', // logout action ID
    logoutDocumentAccess: 'logoutDocumentAccess', // logout document access action ID
    betroffenenRecht: 'betroffenenRechte',
    formular: 'formular', // form Definition
    save: 'save', // zwischenspeichern
    saveUpdate: 'saveUpdate', // zwischenspeichern update
    sessionConfig: 'sessionConfig',
    sessionKeepalive: 'sessionKeepalive',
    downloadAntrag: 'downloadAntrag',
    retrySubmitOnline: 'retrySubmitOnline',
    retrySubmitOffline: 'retrySubmitOffline',
    documentsRefresh: 'documentsRefresh'
  }

  let possibleActions: Actions = {}

  if (result.actions) {
    for (const [key, value] of Object.entries(possibleActionsMap)) {

      for (let action of result.actions) {
        if (action.id === value) {
          possibleActions[key] = action;
        }
      }
    }
  }

  _debug('possibleActions:', possibleActions);
  return possibleActions;
}

// get form features based on API result

export function getFeatures(initialData) {
  // maps action ID's for internal use
  // ToDo: sync naming for easier processing

  let features: Features = {
    supportsSubmitOffline: false,
    formularType: null,
    inactive: false
  };

  const possibleActions = getPossibleActions(initialData);
  const metaData = getMetaData(initialData);

  if (possibleActions.submitOffline) {
    features.supportsSubmitOffline = true;
  }

  if (initialData.formularState === "notBeantragbar") {
    features.inactive = true;
  }

  if (metaData.formularType) {
    features.formularType = metaData.formularType;
  }

  _debug('features:', features);
  return features;
}


// get user decisions from backend state
// currently only the decision about the "preview" is made by user outside the LB App

export function getUserDecisions(initialData) {
  const previewMode = {preview: !!initialData.preview}
  return previewMode;
}


// get user state based on API result

export function getUserState(initialData) {

  let userState: UserState = {
    loggedIn: true,
    accountType: null,
    wrongAccountType: false,
    trustLevelInsufficient: false
  };

  const possibleActions = getPossibleActions(initialData)

  if (initialData.userdata) {
    if (initialData.userdata.kontenTyp) {
      userState.accountType = initialData.userdata.kontenTyp;
    }
    userState.loggedIn = true;
  } else {
    userState.loggedIn = false;
  }

  const metaData = getMetaData(initialData);
  let accountTypeMatches = (metaData.formularType === 'hybrid') ||
    (metaData.formularType === 'buerger' && userState.accountType === 'buerger') ||
    (metaData.formularType === 'organisation' && userState.accountType === 'organisation');

  // wenn account type passt, aber Nutzer sollte sich trotzdem neu einloggen, dann passt höchstwahrscheinlich trustlevel nicht
  userState.trustLevelInsufficient = !!(possibleActions.reloginBuerger || possibleActions.reloginOrganisation) &&
    accountTypeMatches;

  // wenn account type nicht passt...
  userState.wrongAccountType = !!(possibleActions.reloginBuerger || possibleActions.reloginOrganisation) &&
    !accountTypeMatches;

  _debug('userState:', userState);
  return userState;
}

// States explained:
// busy: app is in progress of getting or sending data to base a new state
// ready: app has all the necessary input to show the form-renderer
// not-ready: deprecated: app is not ready to show the form will be replaced be several other states
// trustlevelInsufficient: user is loggd in with an insufficient trust level
// wrongAccountType: user is logged in with an account type (private/oranisation) not matching form account type
// accountTypeDecision: the user is not logged in and can choose between login as organisation or private
// offline: User is looged out and has to login as private person in order to fill out form
// 
// success: form has been successfully submitted

export function getUIState(initialData, userDecisions: UserDecisions, currentUserState: UserState):
  'preview' |
  'accountTypeDecision' |
  'trustlevelInsufficient' |
  'wrongAccountType' |
  'offlineDecision' |
  'formInactive' |
  'ready' |
  'success' {

  _debug("getUIState() entered");
  _debug('getUIState() userDecisions:', userDecisions);
  const initialUserState = getUserState(initialData);
  const userState = (currentUserState.loggedIn === null ||
    (currentUserState.loggedIn === initialUserState.loggedIn)) ? initialUserState : currentUserState;
  const features = getFeatures(initialData);

  if (features.inactive) {
    return 'formInactive';
  }

  if (userDecisions.preview) {
    return 'preview';
  }

  if (userState.wrongAccountType && userDecisions.offline === true) {
    return 'ready';
  }

  if (userState.wrongAccountType) {
    return 'wrongAccountType';
  }

  if (features.formularType === 'hybrid' && !userDecisions.accountType) {
    if (userState.loggedIn && !userState.trustLevelInsufficient) {
      return 'ready';
    }
    if (userState.loggedIn && userState.trustLevelInsufficient) {
      return 'trustlevelInsufficient';
    }
    if (!userState.loggedIn && userDecisions.offline === true) {
      return 'ready';
    } else {
      return 'accountTypeDecision';
    }
  }

  if (userState.trustLevelInsufficient && userDecisions.offline === true) {
    return 'ready';
  }

  if (userState.trustLevelInsufficient && userDecisions.offline === null) {
    return 'trustlevelInsufficient';
  }

  const possibleActions = getPossibleActions(initialData);

  if (userDecisions.offline === null) {
    if (possibleActions.submitOnline && possibleActions.submitOffline) {
      return 'offlineDecision';
    }

    if (possibleActions.submitOffline && possibleActions.loginBuerger) {
      return 'offlineDecision';
    }
  }

  if (possibleActions.submitOffline && userDecisions.offline === true) {
    return 'ready';
  }

  if (possibleActions.submitOnline) {
    return 'ready';
  }

  if (userState.loggedIn === false) {
    return 'trustlevelInsufficient';
  }
}